import { AuthApiManager } from './AuthApiManager';
import { SessionApiManager } from './SessionApiManager';
import { ChatApiManager } from './ChatApiManager';
import { BooksApiManager } from './BooksApiManager';
import { AudioApiManager } from './AudioApiManager';
import { AnalyticsApiManager } from './AnalyticsApiManager';
import { VisualizationApiManager } from './VisualizationApiManager';
import { AdminApiManager } from './AdminApiManager';

// Export specialized API managers
export const authApi = AuthApiManager.getInstance();
export const sessionApi = SessionApiManager.getInstance();
export const chatApi = ChatApiManager.getInstance();
export const booksApi = BooksApiManager.getInstance();
export const audioApi = AudioApiManager.getInstance();
export const analyticsApi = AnalyticsApiManager.getInstance();
export const visualizationApi = VisualizationApiManager.getInstance();
export const adminApi = AdminApiManager.getInstance();

// Export types
export type { ApiResponse, ApiRequestOptions } from './BaseApiManager';

// Convenience export - use authApi as the main instance for utility methods
export const apiManager = authApi;
export default apiManager;
